import { onMounted, onUnmounted, ref } from 'vue'

const LG_MAX = 991.98
const SM_MAX = 575.98

function readViewport() {
  if (typeof window === 'undefined') {
    return { isMobile: false, isSmall: false, width: 1200 }
  }
  const width = window.innerWidth
  return {
    width,
    isMobile: width <= LG_MAX,
    isSmall: width <= SM_MAX,
  }
}

export function useViewport() {
  const width = ref(1200)
  const isMobile = ref(false)
  const isSmall = ref(false)

  function sync() {
    const state = readViewport()
    width.value = state.width
    isMobile.value = state.isMobile
    isSmall.value = state.isSmall
  }

  onMounted(() => {
    sync()
    window.addEventListener('resize', sync, { passive: true })
  })

  onUnmounted(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', sync)
    }
  })

  return { width, isMobile, isSmall }
}
